import React from 'react';
import {Skeleton} from '@zooplus/ui-components';

const SkeletonRewardShop = ({}): JSX.Element => {
  const GLOBAL_PREFIX: string = 'loy-bp-rws-overview';
  return (
    <div className={`${GLOBAL_PREFIX}_items--rebranding`}>
      {Array(15)
        .fill(undefined)
        .map((item, index) => (
          <React.Fragment key={index}>
            <div className={`${GLOBAL_PREFIX}_item--rebranding`} key={index}>
              <div
                className={`${GLOBAL_PREFIX}_item--rebranding_img`}>
                <Skeleton height={'204px'} />
              </div>
              <div
                className={`${GLOBAL_PREFIX}_item--rebranding_info`}>
                <Skeleton height={'104px'} />
              </div>
            </div>
          </React.Fragment>
        ))}
    </div>
  );
};
export default SkeletonRewardShop;
